import { PaintRowDraft } from '../types'

/** Выбранный рецепт карточки — эталон или любая версия пантона. */
export function getReference(draft: PaintRowDraft) {
    return (
        Object.values(draft.versions)
            .flat()
            .find(pantone => pantone.documentId === draft.referencePantoneDocumentId) ?? null
    )
}
